var React = require('react');

function PlusMini (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M9.333 5.836H1V4.167h8.333v1.669Z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M4.333 9.167V.833H6v8.334H4.333Z","clipRule":"evenodd","key":1})]);
}

PlusMini.defaultProps = {"viewBox":"0 0 10 10","fill":"none"};

module.exports = PlusMini;

PlusMini.default = PlusMini;
